import "bootstrap-icons/font/bootstrap-icons.css";
// import "bootstrap/dist/css/bootstrap.min.css";
import ReactDOM from "react-dom/client";
import { NotificationProvider } from "./components/Notification";
import { ThemeProvider } from "./contexts/ThemeContext";
// Biến màu dùng chung — nạp TRƯỚC index.css để stylesheet sau có thể ghi đè
import "./theme/variables.css";
import "./index.css";
// import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import RouterApp from "./router/RouterApp";
const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(<RouterApp />);
root.render(
  <NotificationProvider>
    <ThemeProvider>
      <RouterApp />
    </ThemeProvider>
  </NotificationProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
